export enum CategorizationActionEnum {
    COPY = 'copy',
    MOVE = 'move',
    REMOVE = 'remove',
}
